import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import MessageBoxModal from "./Modals/MessageBoxModal";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import LoginOrSignUpModal from "./Modals/LoginOrSignUpModal";
import {
  BrowserEdge,
  Calendar,
  CardText,
  Chat,
  Coin,
  Envelope,
  Facebook,
  Heart,
  HeartFill,
  Instagram,
  Linkedin,
  PhoneFill,
  Share,
  ShareFill,
  Star,
  StarFill,
  StarHalf,
  TelephoneFill,
  ThreeDots,
  Tiktok,
  Twitch,
  Twitter,
} from "react-bootstrap-icons";
import TimeTable from "./TimeTable";
import Products from "./Products";
import Posts from "./Posts";
import "./OneClub.css";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import { NavDropdown } from "react-bootstrap";
import Reviews from "./Reviews";
import ShareThisClub from "./Modals/ShareThisClub";
import ReportClubModal from "./Modals/ReportClubModal";
import OwnThisClubModal from "./Modals/OwnThisClubModal";
import InactiveClubModal from "./Modals/InactiveClubModal";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import { LightGalleryKeyString } from "../../constants/LightGalleryKey";
import ViewPolicy from "./Modals/ViewPolicy";

export default function OneClub() {
  const { id } = useParams();

  const containsLetter = /[a-zA-Z]/;
  const url = containsLetter.test(id)
    ? `/api/Club/GetByName/${id}`
    : `/api/club/${id}`;

  const [loginModal, setLoginModal] = useState(false);
  const [tokens, setTokens] = useState(0);
  const [clientSecret, setClientSecret] = useState(null);
  const [club, setClub] = useState(null);

  const [convo, setConvo] = useState([]);

  const [checkout, setCheckout] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuthContext();
  const navi = useNavigate();
  const [activeModal, setActiveModal] = useState(false);
  const [rating, setRating] = useState([]);

  const [showReviews, setShowReviews] = useState(false);

  const [buyAndBookObj, setBuyAndBookObj] = useState(null);

  const [clubTag, setClubTag] = useState(false);

  const [mainImages, setMainImages] = useState([]);
  const [images, setImages] = useState([]);

  const [shareclubModal, setShareClubModal] = useState(false);

  const [reportClubModal, setReportClubModal] = useState(false);

  const [ownerClubModal, setOwnerClubModal] = useState(false);
  const [notPremModal, setNotPremModal] = useState(false);
  const [viewPolicyModal, setViewPolicyModal] = useState(false);
  // const [showMembershipOptions, setShowMembershipOptions] = useState(true);
  const [view, setView] = useState("timetable");

  const formatDateWithSuffix = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long" };
    return date.toLocaleDateString("en-GB", options);
  };

  const readableDate = club?.created
    ? formatDateWithSuffix(club.created)
    : null;

  const buyAndBook = (e, t) => {
    setClientSecret(e);
    setCheckout(true);
    cancelModal();
    setBuyAndBookObj(t);
  };

  const [membership, setMembership] = useState([]);

  const cancelModal = () => {
    setActiveModal(false);
    setLoginModal(false);
    setShareClubModal(false);
    setReportClubModal(false);
    setOwnerClubModal(false);
    setViewPolicyModal(false);
  };

  const handleClick = () => {
    if (convo.length == 0) {
      setActiveModal(true);
    } else {
      navi(`/Convo/${convo.club.id}`);
    }
  };

  useEffect(() => {
    if (user && club) {
      if (user.id == club.ownerId) {
        setOwnerClubModal(true);
      }
    }
  }, [user, club]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let clubResponse;
      let err;

      if (user) {
        try {
          clubResponse = await axios.get(`${ApiConnectionString}${url}`, {
            headers: { Authorization: `Bearer ${user.token}` },
          });
        } catch (error) {
          err = true;
          if (error.response.status == 404) {
            navi("/");
          }
        }

        if (!err) {
          try {
            const membershipResponse = await axios.get(
              `${ApiConnectionString}/api/ClubMembers/${user.id}/${id}`,
              {
                headers: { Authorization: `Bearer ${user.token}` },
              }
            );
            setMembership(membershipResponse.data);
          } catch (error) {
            console.error("Error fetching data:", error);
          }

          const convoResponse = await axios.get(
            `${ApiConnectionString}/api/ConvoExists/${user.id}/${clubResponse.data.ownerId}`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          );

          setConvo(convoResponse.data);

          const clubTagResponse = await axios.get(
            `${ApiConnectionString}/api/ClubTagExists/${clubResponse.data.id}`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          );
          setClubTag(clubTagResponse.data);

          const ratingResoponse = await axios.get(
            `${ApiConnectionString}/api/Rating/${clubResponse.data.id}`
          );
          setRating(ratingResoponse.data);
        }
      } else {
        // if not logged in do not include token
        clubResponse = await axios.get(`${ApiConnectionString}${url}`);

        const ratingResoponse = await axios.get(
          `${ApiConnectionString}/api/Rating/${clubResponse.data.id}`
        );
        setRating(ratingResoponse.data);
      }
      setNotPremModal(!clubResponse.data.premium);

      setClub(clubResponse.data);

      if (user) {
        const imageResponse = await axios.get(
          `${ApiConnectionString}/api/images?ClubId=${clubResponse.data.id}&ClubImage=true`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );
        const orderedImages = imageResponse.data.sort(
          (a, b) => a.clubImageIndex - b.clubImageIndex
        );

        setImages(orderedImages);
        // setMainImages(imageResponse.data.filter((image) => image.mainImage));
      } else {
        const imageResponse = await axios.get(
          `${ApiConnectionString}/api/images?ClubId=${clubResponse.data.id}&ClubImage=true`
        );
        const orderedImages = imageResponse.data.sort(
          (a, b) => a.clubImageIndex - b.clubImageIndex
        );

        setImages(orderedImages);
        // setMainImages(imageResponse.data.filter((image) => image.mainImage));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // This ensures loading stops even if there's an error
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, [user, id]);

  const calculateAverageRating = () => {
    if (rating.length === 0) return 0;

    const totalStars = rating.reduce((sum, review) => sum + review.stars, 0);
    return totalStars / rating.length;
  };

  const averageRating = calculateAverageRating();
  const totalReviews = rating.length;
  const fullStars = Math.floor(averageRating);
  const hasHalfStar = averageRating % 1 >= 0.5;

  const closeReviews = () => {
    setShowReviews(false);
  };

  const renderLayout = () => {
    if (images.length === 1) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            <div className="col-12">
              <a
                href={`${ApiConnectionString}/api/Image/${images[0].id}`}
                className="lightgallery-item"
              >
                <img
                  src={`${ApiConnectionString}/api/Image/${images[0].id}`}
                  alt="Club"
                  className="img-fluid rounded border w-100"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
              </a>
            </div>
          </div>
        </LightGallery>
      );
    }

    if (images.length === 2) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            {images.map((img) => (
              <div className="col-12" key={img.id}>
                <a
                  href={`${ApiConnectionString}/api/Image/${img.id}`}
                  className="lightgallery-item"
                >
                  <img
                    src={`${ApiConnectionString}/api/Image/${img.id}`}
                    alt="Club"
                    className="img-fluid rounded border w-100"
                    style={{ aspectRatio: "1/1", objectFit: "cover" }}
                  />
                </a>
              </div>
            ))}
          </div>
        </LightGallery>
      );
    }

    if (images.length === 3) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            <div className="col-12">
              <a
                href={`${ApiConnectionString}/api/Image/${images[0].id}`}
                className="lightgallery-item"
              >
                <img
                  src={`${ApiConnectionString}/api/Image/${images[0].id}`}
                  alt="Club"
                  className="img-fluid rounded border w-100"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
              </a>
            </div>

            {images.slice(1).map((img) => (
              <div className="col-6" key={img.id}>
                <a
                  href={`${ApiConnectionString}/api/Image/${img.id}`}
                  className="lightgallery-item"
                >
                  <img
                    src={`${ApiConnectionString}/api/Image/${img.id}`}
                    alt="Club"
                    className="img-fluid rounded border w-100"
                    style={{ aspectRatio: "1/1", objectFit: "cover" }}
                  />
                </a>
              </div>
            ))}
          </div>
        </LightGallery>
      );
    }

    if (images.length === 4) {
      return (
        <LightGallery
          licenseKey={LightGalleryKeyString}
          selector=".lightgallery-item"
        >
          <div className="row g-2">
            {images.map((img) => (
              <div className="col-6" key={img.id}>
                <a
                  href={`${ApiConnectionString}/api/Image/${img.id}`}
                  className="lightgallery-item"
                >
                  <img
                    src={`${ApiConnectionString}/api/Image/${img.id}`}
                    alt="Club"
                    className="img-fluid rounded border w-100"
                    style={{ aspectRatio: "1/1", objectFit: "cover" }}
                  />
                </a>
              </div>
            ))}
          </div>
        </LightGallery>
      );
    }

    return (
      <LightGallery
        licenseKey={LightGalleryKeyString}
        selector=".lightgallery-item"
      >
        <div className="row g-2">
          {images.map((img) => (
            <div className="col-6" key={img.id}>
              <a
                href={`${ApiConnectionString}/api/Image/${img.id}`}
                className="lightgallery-item"
              >
                <img
                  src={`${ApiConnectionString}/api/Image/${img.id}`}
                  alt="Club"
                  className="img-fluid rounded border w-100"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
              </a>
            </div>
          ))}
        </div>
      </LightGallery>
    );
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else if (club) {
    return (
      <div>
        <div className="container mt-3">
          <div className="d-flex justify-content-end mb-0">
            <button
              onClick={() => setShareClubModal(true)}
              className="btn btn-dark btn-sm d-flex"
            >
              <ShareFill size={20} className="mb-0 mx-3 pointer" />
              Share
            </button>
          </div>
        </div>

        <div className="container bg-white">
          <div className="d-flex justify-content-end mb-0">
            <div className="d-flex align-items-center mb-0 mt-2">
              {user && (
                <NavDropdown
                  title={<ThreeDots size={25} className="pointer" />}
                  className="dropdown-toggle mb-0"
                >
                  <NavDropdown.Item
                    onClick={() => {
                      setReportClubModal(true);
                    }}
                  >
                    Report Club
                  </NavDropdown.Item>
                  {club.policyUpdated && (
                    <NavDropdown.Item
                      onClick={() => {
                        setViewPolicyModal(true);
                      }}
                    >
                      View Club Policy
                    </NavDropdown.Item>
                  )}
                </NavDropdown>
              )}
            </div>
          </div>

          <div className="row mx-4 mt-0">
            <div className="col-12 col-md-6">
              {!isLoading && club.image ? (
                <LightGallery
                  licenseKey={LightGalleryKeyString}
                  elementClassNames="circle-crop image-container pointer"
                >
                  <a
                    href={`${ApiConnectionString}/api/ClubProfileImage/${club.id}`}
                  >
                    <img
                      src={`${ApiConnectionString}/api/ClubProfileImage/${club.id}`}
                      alt="Club Image"
                      className="mt-0"
                    />
                  </a>
                </LightGallery>
              ) : (
                !isLoading && (
                  <div className="circle-crop image-container pointer">
                    <img
                      src={NoImagePlaceholder}
                      alt="Club Image"
                      className="mt-0"
                    />
                  </div>
                )
              )}
              <p className="text-muted mb-0 mt-4">Joined {readableDate} </p>
              <p className="fontSize30 fw-bold mb-0">{club.name}</p>

              <p>
                {club.address}, {club.city}, {club.county}, {club.postCode}
              </p>
              {user && (
                <div className="pointer d-flex mb-0" onClick={handleClick}>
                  {" "}
                  <p className="mb-0">Send Message</p>{" "}
                  <Chat size={25} className="mx-2 mb-0" />
                </div>
              )}

              <div
                className="d-flex align-items-center pointer"
                onClick={() => setShowReviews(true)}
              >
                {[...Array(5)].map((_, index) => {
                  if (index < fullStars) {
                    return <StarFill key={index} />;
                  } else if (index === fullStars && hasHalfStar) {
                    return <StarHalf key={index} />;
                  } else {
                    return <Star key={index} />;
                  }
                })}
                <p className="mx-2 mt-4">
                  {averageRating.toFixed(1)} • {totalReviews} reviews
                </p>
              </div>
              {showReviews && user && (
                <Reviews
                  rating={rating}
                  id={club.id}
                  closeReviews={closeReviews}
                  refreshData={fetchData}
                />
              )}
              <hr className="mb-3 mt-0" width="50%" />
              <p>{club.description}</p>
              {club.phoneNumber && (
                <div className="d-flex">
                  <div className="d-flex icon-container">
                    <TelephoneFill className="icon" />
                  </div>
                  <p className="mx-2 my-2 fw-bold">{club.phoneNumber}</p>
                </div>
              )}
              {club.email && (
                <div className="d-flex mt-2">
                  <div className="d-flex icon-container">
                    <Envelope className="icon" />
                  </div>
                  <p className="mx-2 my-2 fw-bold">{club.email}</p>
                </div>
              )}
              {club.website && (
                <div className="d-flex mt-2">
                  <div className="d-flex icon-container">
                    <BrowserEdge className="icon" />
                  </div>
                  <p className="mx-2 my-2 fw-bold">{club.website}</p>
                </div>
              )}

              <div className="my-4">
                <div className="d-flex">
                  {club.facebook && (
                    <a href={club.facebook}>
                      <Facebook className="social-icon" />
                    </a>
                  )}
                  {club.twitter && (
                    <a href={club.twitter}>
                      <Twitter className="social-icon" />
                    </a>
                  )}
                  {club.instagram && (
                    <a href={club.instagram}>
                      <Instagram className="social-icon" />
                    </a>
                  )}
                </div>
                <div className="d-flex">
                  {club.linkedin && (
                    <a href={club.linkedin}>
                      <Linkedin className="social-icon" />
                    </a>
                  )}
                  {club.tikTok && (
                    <a href={club.tikTok}>
                      {" "}
                      <Tiktok className="social-icon" />{" "}
                    </a>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 mt-5">
              {renderLayout()}
              {/* {club.premium && <Posts id={club.id} />} */}
            </div>
          </div>

       {club.premium && (
  <div className="container mt-4">
    <div className="btn-group w-100 mb-3" role="group">

      <button
        type="button"
        className={`btn w-33 ${
          view === "membership" ? "toggle-pink" : "toggle-pink-outline"
        }`}
        onClick={() => setView("membership")}
      >
        <Coin className="fs-3" />
        <span className="d-none d-md-inline ms-2">Membership options</span>
      </button>

      <button
        type="button"
        className={`btn w-33 ${
          view === "timetable" ? "toggle-pink" : "toggle-pink-outline"
        }`}
        onClick={() => setView("timetable")}
      >
        <Calendar className="fs-3" />
        <span className="d-none d-md-inline ms-2">Time Table</span>
      </button>

      <button
        type="button"
        className={`btn w-33 ${
          view === "posts" ? "toggle-pink" : "toggle-pink-outline"
        }`}
        onClick={() => setView("posts")}
      >
        <CardText className="fs-3" />
        <span className="d-none d-md-inline ms-2">Posts</span>
      </button>

    </div>

    {view === "membership" && (
      <Products id={club.id} club={club} fetchData={fetchData} />
    )}

    {view === "timetable" && (
      <TimeTable
        id={club.id}
        buyAndBook={buyAndBook}
        club={club}
        refreshData={fetchData}
      />
    )}

    {view === "posts" && <Posts id={club.id} />}
  </div>
)}


          {/* {club.premium && (
            <div className="container mt-4">
              <div className="btn-group w-100 mb-3" role="group">
                <button
                  type="button"
                  className={`btn w-50 ${
                    showMembershipOptions
                      ? "toggle-pink"
                      : "toggle-pink-outline"
                  }`}
                  onClick={() => setShowMembershipOptions(true)}
                >
                  Membership options
                </button>

                <button
                  type="button"
                  className={`btn w-50 ${
                    !showMembershipOptions
                      ? "toggle-pink"
                      : "toggle-pink-outline"
                  }`}
                  onClick={() => setShowMembershipOptions(false)}
                >
                  Timetable
                </button>
              </div>

              {showMembershipOptions && (
                <Products id={club.id} club={club} fetchData={fetchData} />
              )}

              {!showMembershipOptions && (
                <TimeTable
                  id={club.id}
                  buyAndBook={buyAndBook}
                  club={club}
                  refreshData={fetchData}
                />
              )}
            </div>
          )} */}

          {activeModal && (
            <MessageBoxModal
              receiverName={club.ownerName}
              receiverId={club.ownerId}
              cancelModal={cancelModal}
            />
          )}

          {loginModal && <LoginOrSignUpModal cancelModal={cancelModal} />}

          {shareclubModal && (
            <ShareThisClub cancelModal={cancelModal} urlName={club.urlName} />
          )}

          {reportClubModal && (
            <ReportClubModal club={club} cancelModal={cancelModal} />
          )}
          {ownerClubModal && (
            <OwnThisClubModal cancelModal={cancelModal} id={club.id} />
          )}
          {notPremModal && <InactiveClubModal />}

          {viewPolicyModal && (
            <ViewPolicy cancelModal={cancelModal} clubId={id} />
          )}
        </div>
      </div>
    );
  }
}
